<div class="stick-top">
  <mat-toolbar><mat-icon>album</mat-icon> Disk Profiles</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/diskProfiles/0">
      <mat-icon aria-label="Create a new Disk Profile">add</mat-icon>
      Create a new Disk Profile
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
        </div>
      </th>
      <th><div class="vbox">Code<input [(ngModel)]="filter.code"></div></th>
      <th><div class="vbox">Name<input [(ngModel)]="filter.name"></div></th>
      <th><div class="vbox">Description<input [(ngModel)]="filter.description"></div></th>
      <th><div class="vbox">Active<input [(ngModel)]="filter.active"></div></th>
      <th><div class="vbox">Template<input [(ngModel)]="filter.template"></div></th>
      <th><div class="vbox">Platform<input [(ngModel)]="filter.platform"></div></th>
      <th><div class="vbox">OS Version<input [(ngModel)]="filter.osVersion"></div></th>
      <th><div class="vbox">OS Default Disk Size<input [(ngModel)]="filter.osDefaultDiskSize"></div></th>
      <th><div class="vbox">Min GB<input [(ngModel)]="filter.minGB"></div></th>
      <th><div class="vbox">Max GB<input [(ngModel)]="filter.maxGB"></div></th>
      <th><div class="vbox">OS Disk Type<input [(ngModel)]="filter.osDiskType"></div></th>
      <th><div class="vbox">OS Mount<input [(ngModel)]="filter.osMount"></div></th>
      <th><div class="vbox">Reason<input [(ngModel)]="filter.reason"></div></th>
      <th><div class="vbox">Max Additional Disks<input [(ngModel)]="filter.maxAdditionalDisks"></div></th>
      <th><div class="vbox">Max Total Disks<input [(ngModel)]="filter.maxTotalDisks"></div></th>
      <th><div class="vbox">Storage Tier<input [(ngModel)]="filter.storageTier"></div></th>
      <th><div class="vbox">Encryption Mandatory<input [(ngModel)]="filter.encryptionMandatory"></div></th>
      <th><div class="vbox">Engineer Add<input [(ngModel)]="filter.engineerAdd"></div></th>
      <th><div class="vbox">Engineer Resize<input [(ngModel)]="filter.engineerResize"></div></th>
      <th><div class="vbox">Notes<input [(ngModel)]="filter.notes"></div></th>

    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td>{{element.code}}</td>
      <td><a routerLink="/diskProfiles/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.description}}</td>
      <td>{{element.active}}</td>
      <td>{{element.templateId}}</td>
      <td>{{element.platformName}}</td>
      <td>{{element.osVersionName}}</td>
      <td>{{element.osDefaultDiskSize}}</td>
      <td>{{element.minGB}}</td>
      <td>{{element.maxGB}}</td>
      <td>{{element.osDiskType}}</td>
      <td>{{element.osMount}}</td>
      <td>{{element.reason}}</td>
      <td>{{element.maxAdditionalDisks}}</td>
      <td>{{element.maxTotalDisks}}</td>
      <td>{{element.storageTier}}</td>
      <td>{{element.encryptionMandatory}}</td>
      <td>{{element.engineerAdd}}</td>
      <td>{{element.engineerResize}}</td>
      <td>{{element.notes}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
